"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorSwatch = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("../../styles/context");
const BasicTooltip_1 = require("../../4-card/BasicTooltip");
const buttonClass = (0, nano_theme_1.drule)({
    d: 'inline-flex',
    jc: 'center',
    ai: 'center',
    out: 0,
    bd: 0,
    bxz: 'border-box',
    us: 'none',
    cur: 'pointer',
    pos: 'relative',
    flexShrink: 0,
    fz: '13px',
    fw: 600,
    lh: '1',
    ff: 'inherit',
    pd: 0,
    '&:focus-visible': {
        out: '2px solid currentColor',
        outOffset: '2px',
    },
});
const ringClass = (0, nano_theme_1.rule)({
    pos: 'absolute',
    pointerEvents: 'none',
});
const ColorSwatch = ({ color, textColor, kind = 'plain', size = 28, active, letter = 'A', tooltip, disabled, onClick, onMouseDown, }) => {
    const styles = (0, context_1.useStyles)();
    const isFg = kind === 'fg';
    const fillColor = isFg ? styles.g(1, 0.0) : color;
    const glyphColor = isFg ? color : (textColor ?? '#FFFFFF');
    const showLetter = kind === 'fg' || kind === 'fgbg';
    const cls = buttonClass({
        w: size + 'px',
        h: size + 'px',
        bg: fillColor,
        bdrad: '6px',
        bd: `1px solid ${styles.g(0, 0.12)}`,
        op: disabled ? 0.5 : 1,
        '&:hover': disabled ? {} : { bd: `1px solid ${styles.g(0, 0.4)}` },
    });
    const button = (React.createElement("button", { type: "button", className: cls, disabled: disabled, onClick: onClick, onMouseDown: onMouseDown },
        showLetter ? React.createElement("span", { style: { color: glyphColor } }, letter) : null,
        active ? (React.createElement("span", { className: ringClass, style: {
                inset: -3,
                borderRadius: 8,
                border: `2px solid ${styles.col.accent(0, 'solid-1')}`,
            } })) : null));
    if (!tooltip)
        return button;
    return (React.createElement(BasicTooltip_1.BasicTooltip, { nowrap: true, ...tooltip, show: disabled ? false : tooltip.show }, button));
};
exports.ColorSwatch = ColorSwatch;
